/**
 * Whether a result is sitting in the list with no patient behind it.
 *
 * Worth a named check rather than an inline `!row.patientId`: the same row can carry
 * the patient as an id, as an embedded object, or as neither, and the lists mix
 * assigned and unassigned rows outside the Unmatched view too — an unassigned result
 * is not on any chart, so it is invisible to everyone except whoever happens to
 * scroll past it here.
 */
export const isResultUnassigned = (result) =>
  !result?.patientId && !result?.patient?.id && !result?.patient;
